import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-cash-1 bg-grey-50" }
const _hoisted_2 = { class: "s15_mobile px-4" }
const _hoisted_3 = { class: "widget px-7 py-7" }
const _hoisted_4 = { class: "tabs" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "tab-content" }
const _hoisted_7 = {
  key: 0,
  class: "text-red"
}
const _hoisted_8 = { class: "flex gap-2" }
const _hoisted_9 = { class: "s5_mobile px-4" }
const _hoisted_10 = { class: "widget px-7 py-7" }
const _hoisted_11 = { class: "custom-upload-size margin-auto flex mb-8" }

import { onMounted, reactive, ref, toRaw } from 'vue';
    import axios from 'axios';
    import { useRoute, useRouter } from 'vue-router';
    import ConfirmationModal from '@/components/ConfirmationModal.vue';
    import MarketProduitFormGeneralView from './views/MarketProduitFormGeneralView.vue';
    import MarketProduitFormPricesView from './views/MarketProduitFormPricesView.vue';
    import MarketProduitFormAttributsView from './views/MarketProduitFormAttributsView.vue';
    import MarketProduitFormPromotionView from './views/MarketProduitFormPromotionView.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MarketProduitsFormView',
  setup(__props) {

    const router = useRouter();
    const route = useRoute();
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const formData = reactive({
        id: "",
        image: null as any,
        image_preview: '/assets/users/default.png',
    });
    const generalFormData = ref({
        categorie_ids: [] as any[],
        sku: "",
        ean: "",
        nom: "",
        description: "",
        montant: 0,
        metadata: [] as any[],
        fournisseurs_ids: [] as any[],
        quantite: 0,
    });
    const echeancesFormData = ref({
        echeances: [] as any[],
        mode_paiement: 'cash',
    });
    const promotionFormData = ref({
        type_promotion: null as string | null,
        taux_promotion: 0
    });
    const attributsFormData = reactive({
        attributs: [] as any[],
        produit_attributs: [] as any[],
    });
    const errors = reactive({
        image: "",
    });
    const startupFormDatas = reactive({
        attributs: [] as any[],
        categories: [] as any[],
        fournisseurs: [] as any[],
        echeances: [] as any[],
        types_promotion: [] as any[],
        produit: {} as any,
        market_echeances_time: -1,
        market_delivery_time: -1,
    });
    const tabs = ['Infos Produit', 'Tarifs & Paiement', 'Promotion', 'Attributs'];
    const activeTab = ref('Infos Produit');

    onMounted(() => {
        const form_datas: any = route.meta.form_datas;
        Object.assign(startupFormDatas, {
            attributs: form_datas?.attributs || [],
            categories: form_datas?.categories || [],
            fournisseurs: form_datas?.fournisseurs || [],
            echeances: form_datas?.echeances || [],
            types_promotion: form_datas?.types_promotion || [],
            produit: form_datas?.produit || {},
            market_echeances_time: form_datas?.market_echeances_time || -1,
            market_delivery_time: form_datas?.market_delivery_time || -1,
        });
        if (form_datas?.produit) {
            const item = form_datas.produit as any;
            formData.id = item.id;
            if (item.image !== undefined) {
                formData.image_preview = item.image_url;
            }

            generalFormData.value = {
                categorie_ids: item.categorie_ids || [],
                sku: item.sku || "",
                ean: item.ean || "",
                nom: item.nom || "",
                description: item.description || "",
                montant: item.montant || 0,
                metadata: item.metadata || [],
                fournisseurs_ids: item.fournisseurs_ids || [],
                quantite: item.quantite || 0,
            };

            echeancesFormData.value = {
                echeances: item.echeances || [],
                mode_paiement: item.mode_paiement || 'cash',
            };

            promotionFormData.value = {
                type_promotion: item.type_promotion || null,
                taux_promotion: item.taux_promotion || 0,
            };

            Object.assign(attributsFormData, {
                attributs: item.attributs || [],
                produit_attributs: item.produit_attributs || [],
            });
        }
    });

    function validate() {
        let isValid = true;
        
        isFormValid.value = isValid;

        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const formToUpload = new FormData();
            if (formData.id != null) {
                formToUpload.append("id", `${formData.id}`);
            }
            if (formData.image?.file) {
                formToUpload.append("image", formData.image.file, formData.image.name);
            }
            
            formToUpload.append("categorie_ids", generalFormData.value.categorie_ids ? JSON.stringify(generalFormData.value.categorie_ids) : '[]');
            formToUpload.append("sku", generalFormData.value.sku);
            formToUpload.append("ean", generalFormData.value.ean);
            formToUpload.append("nom", generalFormData.value.nom);
            formToUpload.append("quantite", generalFormData.value.quantite.toString());
            formToUpload.append("description", generalFormData.value.description);
            formToUpload.append("montant", generalFormData.value.montant.toString());
            formToUpload.append("metadata", generalFormData.value.metadata ? JSON.stringify(generalFormData.value.metadata) : '[]');
            formToUpload.append("fournisseurs_ids", generalFormData.value.fournisseurs_ids ? JSON.stringify(generalFormData.value.fournisseurs_ids) : '[]');

            formToUpload.append("type_promotion", promotionFormData.value.type_promotion ? promotionFormData.value.type_promotion : '');
            formToUpload.append("taux_promotion", promotionFormData.value.taux_promotion.toString());

            formToUpload.append("echeances", echeancesFormData.value.echeances ? JSON.stringify(echeancesFormData.value.echeances) : '[]');
            formToUpload.append("mode_paiement", echeancesFormData.value.mode_paiement ? echeancesFormData.value.mode_paiement : 'cash');

            formToUpload.append("attributs", attributsFormData.attributs ? JSON.stringify(attributsFormData.attributs.map(a => a.id)) : '[]');

            attributsFormData.produit_attributs.forEach((produit_attribut: any, index: number) => {
                if (produit_attribut.image?.file) {
                    formToUpload.append(`produit_attributs[${index}][image]`, produit_attribut.image.file, produit_attribut.image.name);
                } else {
                    formToUpload.append(`produit_attributs[${index}][image]`, '');
                }
                formToUpload.append(`produit_attributs[${index}][guid]`, produit_attribut.guid);
                formToUpload.append(`produit_attributs[${index}][montant]`, produit_attribut.montant.toString());
                formToUpload.append(`produit_attributs[${index}][quantite]`, produit_attribut.quantite.toString());
                formToUpload.append(`produit_attributs[${index}][produit_attributs]`, produit_attribut.produit_attributs ? JSON.stringify(produit_attribut.produit_attributs) : '[]');
            });

            await axios.post(`/backoffice/market-produits/save`, formToUpload);
            router.push('/app/market/market-produits/list');
        } catch (error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    function onFileImageUploaded(uploadedFile: { file: any, file_name: string, file_preview: string }) {
        formData.image_preview = uploadedFile.file_preview;
        formData.image = { file: uploadedFile.file, name: uploadedFile.file_name };
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_button = _resolveComponent("custom-button")!
  const _component_custom_upload_input = _resolveComponent("custom-upload-input")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "page-space-30" }, null, -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "font-semibold mb-5" }, [
          _createTextVNode("Produits Market / Edition "),
          _createElementVNode("span", { class: "text-sm text-grey-500" })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
            return _createElementVNode("button", {
              key: tab,
              class: _normalizeClass({ active: activeTab.value === tab }),
              onClick: ($event: any) => (activeTab.value = tab)
            }, _toDisplayString(tab), 11, _hoisted_5)
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(MarketProduitFormGeneralView, {
              startupFormDatas: startupFormDatas,
              modelValue: generalFormData.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((generalFormData).value = $event))
            }, null, 8, ["startupFormDatas", "modelValue"])
          ], 512), [
            [_vShow, activeTab.value === 'Infos Produit']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(MarketProduitFormPricesView, {
              startupFormDatas: startupFormDatas,
              modelValue: echeancesFormData.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((echeancesFormData).value = $event))
            }, null, 8, ["startupFormDatas", "modelValue"])
          ], 512), [
            [_vShow, activeTab.value === 'Tarifs & Paiement']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(MarketProduitFormPromotionView, {
              startupFormDatas: startupFormDatas,
              modelValue: promotionFormData.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((promotionFormData).value = $event))
            }, null, 8, ["startupFormDatas", "modelValue"])
          ], 512), [
            [_vShow, activeTab.value === 'Promotion']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(MarketProduitFormAttributsView, {
              startupFormDatas: startupFormDatas,
              modelValue: attributsFormData,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((attributsFormData) = $event)),
              imagePreview: formData.image_preview
            }, null, 8, ["startupFormDatas", "modelValue", "imagePreview"])
          ], 512), [
            [_vShow, activeTab.value === 'Attributs']
          ])
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
        (!!errorMessage.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true),
        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-text-xs text-grey-500 mb-5" }, [
          _createElementVNode("b", { class: "color-danger text-xs" }, "*"),
          _createTextVNode(" Les champs marqués d'un astérisque sont obligatoires")
        ], -1)),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_custom_button, {
            id: "btn-submit",
            type: "button",
            classesList: 'btn lg w-100',
            loading: loading.value,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (onSubmit()))
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createElementVNode("img", {
                src: "/icons/icon-enregistrer.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Enregistrer", -1)
            ]))]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _cache[9] || (_cache[9] = _createElementVNode("h4", { class: "font-semibold mb-5 text-center" }, [
          _createTextVNode("Image "),
          _createElementVNode("span", { class: "text-sm text-grey-500" })
        ], -1)),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_custom_upload_input, {
            id: "image",
            label: "Image",
            type: "IMAGE",
            preview: formData.image_preview,
            onUploaded: onFileImageUploaded
          }, null, 8, ["preview"])
        ])
      ])
    ])
  ]))
}
}

})